import * as network from '../../pixelstreaming/network';
import { ThreeView } from '../../view3d/webcad';

export class R2MConnect {

    private abController: AbortController | null = null;

    private TRY_SPAN = 1000;

    constructor() { }

    public execute() {
        if (this.abController) {
            this.abController.abort();
            const communication = ThreeView.get().pscommunication as network.R2MCommunication;
            communication.reset();
            this.abController = undefined;
            return;
        }

        this.tryConnect();
    }

    private async tryConnect() {
        console.log('- tryConnect -');
        const element = document.getElementById('btnRendering');

        const communication = ThreeView.get().pscommunication as network.R2MCommunication;
        const status = communication.status;

        if (status == -100) return;
        if (status == network.statustype.unknown || status == network.statustype.disconnect) {
            ThreeView.get().unSelectedObject();
            if (status == network.statustype.unknown) {
                element.innerHTML = '<span class="jp">接続中</span><span class="en">◎Connecting</span>';
            }
            communication.UserRegistration()
                .then(async () => {
                    // unknown, disconnectならサーバアクセス
                    const result = await communication.serverAccess();
                    // 接続待ちなら
                    if (!result.ready) {
                        element.innerHTML = `<span class="jp">接続待ち: ${result.waiting + 1}</span><span class="en">◎Waiting</span>`;
                        this.retryConnect();
                    }
                });
        } else if (status == network.statustype.wait) {
            const result = await communication.serverAccess();
            // 接続待ちなら
            if (!result.ready) {
                element.innerHTML = `<span class="jp">接続待ち: ${result.waiting + 1}</span><span class="en">◎Waiting</span>`;
                this.retryConnect();
            }
        } else {
            element.innerHTML = '<span class="jp">接続解除</span><span class="en">◎Connecting</span>';
            // connectならサーバ接続解除
            communication.disconnect();
            communication.resetUser();
        }
    };

    private retryConnect() {
        this.abController = new AbortController();
        const { signal } = this.abController;

        const timerID = setTimeout(() => {
            this.tryConnect()
        }, this.TRY_SPAN);

        signal.addEventListener(
            "abort",
            () => {
                clearTimeout(timerID);
            },
            {
                once: true,
            }
        );
    }
}
